import React from "react";
import io from "socket.io-client";

export const socket = io.connect(process.env.REACT_APP_URI);
// export const socket = io.connect(process.env.REACT_APP_URI, {
//   query: {
//     token: localStorage.getItem('token'),
//   },
// });
export const SocketContext = React.createContext();
